// extracted by mini-css-extract-plugin
export var errorIcon = "_o3-1";
export var nameLogo = "_o3-0";